(function ($) {

    $.fn.customTooltip = function () {
        const showText = 'show-text';
        const longText = 'long-text';
        const alignRight = 'align-right';

        this.each((i, el) => {
            const $self = $(el);
            
            $self.on('click', (e) => {
                const $tooltip = $(e.target);
                const currentBreakpoint = window.currentBreakpoint();
                
                if($tooltip.hasClass('fr-custom-tooltip')){
                    if(!$tooltip.hasClass(showText)){
                        hideAllTooltips();
                        reset($tooltip);
                        $tooltip.addClass(showText);
                        checkTextWidth($tooltip);
                        repositionTooltip($tooltip, ['xs', 'sm'].includes(currentBreakpoint));
                    }else{
                        reset($tooltip);
                    }
                }

                //clase defination tooltip
                $('body').find('.fr-definition-tooltip.show-text').each(function (index, domEle) {
                    $(domEle).removeClass('show-text');
                });
            });


            $self.find('.tooltip-text').on('click', (e) => {
                const $tooltipText = $(e.target);
                const $tooltip = $tooltipText.parent('.fr-custom-tooltip');
                reset($tooltip);            
            });
        });

        function checkTextWidth($tooltip){
            const $text = $tooltip.find('.tooltip-text');
            if($text[0].scrollWidth > $text[0].clientWidth){
                $text.addClass(longText);
            }
            $text.addClass('visible');
        }

        function repositionTooltip($tooltip, isMobile = false){
            const $tooltipText = $tooltip.find('.tooltip-text');
            if(isMobile){
                const offset = $tooltipText.offset().left;
                offset < 0 ? $tooltipText.css('right', offset - (15 / 2)) : $tooltipText.css('left', offset);
            }else{
                if($tooltipText.offset().left < $('.entry-content').offset().left){
                    $tooltipText.addClass(alignRight);
                }
            }
        }

        function reset($tooltip){
            $tooltip.removeClass(showText);
            $tooltip.find('.tooltip-text').attr('style', '');
            $tooltip.find('.tooltip-text').removeClass(alignRight);
            $tooltip.find('.tooltip-text').removeClass(longText);
            $tooltip.find('.tooltip-text').removeClass('visible');
        }

        function hideAllTooltips(){
            $('.fr-custom-tooltip').removeClass(showText);
            $('.fr-custom-tooltip').find('.tooltip-text').removeClass(alignRight);
            $('.fr-custom-tooltip').find('.tooltip-text').removeClass(longText);
            $('.fr-custom-tooltip').find('.tooltip-text').removeClass('visible');
        }

        return this;
    }

    $(() => {
        $('.fr-custom-tooltip').customTooltip();
    });

})($);


// WEBPACK FOOTER //
// ./scripts/components/tooltip.js